mcWeb.salesConditions = new function () {

    this.events = {
    }

    this.vm = function (id) {
        var self = this;
        this.id = "#" + id;

        self.hasCartItems = ko.observable(false);
        self.showConditons = ko.observable(false);

        this.load = function (data, settings) {};

        this.onClickConditions = function () {
            self.showConditons(!self.showConditons());
        }

        PubSub.subscribe(mcWeb.cart.events.hasCartItems, function (message, hasCartItems) {
            if (hasCartItems != null) {
                self.hasCartItems(hasCartItems);           
            }
        });
    };
};
